export const greyDarker = "var(--grey-darker)"
export const greyLighter = "var(--grey-lighter)"
export const containerFixed = "71.5rem"
export const containerFluid = "100%"
